import { Component, Mixins, Prop } from "vue-property-decorator";

import { FaqUrl, WebsiteUrl } from "@/mixins";

@Component({
  components: {},
})
export default class VSideLinks extends Mixins(WebsiteUrl, FaqUrl) {
  @Prop() colorProp!: string;

  color = "";
  created() {
    if (!this.colorProp) {
      this.color = "white";
    } else {
      this.color = "black";
    }
  }

  get des() {
    return `
    Join Nothing Really Mattress Contest to reward yourself a chance to win exclusive IKEA cash vouchers worth RM23,000! Stay tuned for our weekly announcements if you have submitted your entries. View ${this.$m_currentUrl} for more information. `;
  }

  public get icons() {
    return {
      black: {
        fb: require("@/assets/icons/d-fb-vote-share-icon.svg"),
        wa: require("@/assets/icons/d-WA-vote-share-icon.svg"),
        mes: require("@/assets/icons/D-messenger-icon-b.svg"),
        wab: require("@/assets/icons/D-WAbuss-icon-b.svg"),
        email: require("@/assets/icons/D-email-icon-b.svg"),
        faq: require("@/assets/icons/D-faq-icon-b.svg"),
      },

      white: {
        fb: require("@/assets/icons/D-fb-icon.svg"),
        wa: require("@/assets/icons/D-WA-icon.svg"),
        mes: require("@/assets/icons/D-messenger-icon.svg"),
        wab: require("@/assets/icons/D-WAbuss-icon.svg"),
        email: require("@/assets/icons/D-email-icon.svg"),
        faq: require("@/assets/icons/D-faq-icon.svg"),
      },
    };
  }
}
